import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import CheckboxCheckedIcon from '../icons/CheckboxCheckedIcon';
import CheckboxUncheckedIcon from '../icons/CheckboxUncheckedIcon';
import Typography from '../Typography';
import FormLabel from '../FormLabel';

function TermsInput(props) {
  const { className, meta, classes, input, label, linkText, linkAddress } = props;
  const error = Boolean(meta && meta.touched && meta.error);
  const Icon = input.value ? CheckboxCheckedIcon : CheckboxUncheckedIcon;

  return (
    <label className={classNames(className, classes.root, error && classes.error)}>
      {error && (
        <FormLabel>
          <span className={classes.fieldLabelParticle}>
            {meta.error || <FormattedMessage id="required" />}
          </span>
        </FormLabel>
      )}
      <div className={classes.row}>
        <input type="checkbox" checked={input.value} onChange={input.onChange} hidden />
        <Icon
          className={classNames(classes.icon, classes.checkbox, input.value && classes.checked)}
        />
        <Typography className={classes.label} type="caption">
          {label}{' '}
          {linkAddress ? (
            <Typography type="caption" component="a" href={linkAddress} target="_blank">
              {linkText ? linkText : linkAddress}
            </Typography>
          ) : linkText ? (
            <Typography type="caption">{linkText}</Typography>
          ) : null}
        </Typography>
      </div>
    </label>
  );
}

TermsInput.propTypes = {
  classes: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkAddress: PropTypes.string.isRequired,
  className: PropTypes.string,
  meta: PropTypes.object,
};

TermsInput.defaultProps = {
  className: null,
  meta: null,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.unit,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    border: [2, 'solid', theme.palette.error[500]],
  },
  label: {
    flex: 1,
    marginLeft: theme.spacing.unit,
  },
  icon: {
    cursor: 'pointer',
    transition: `color ${theme.transitions.duration.short}ms`,
    '&:hover': {
      color: theme.palette.success[500],
    },
  },
  checkbox: {
    // empty class to be used by "checked"
  },
  checked: {
    color: theme.palette.success[500],
    '&:hover $checkbox&': {
      color: theme.palette.success[300],
    },
  },
  fieldLabelParticle: {
    marginLeft: 4 * theme.spacing.unit,
    '$error &': {
      color: theme.palette.error[500],
    },
  },
});

export default injectSheet(stylesheet)(TermsInput);



// WEBPACK FOOTER //
// ./src/site-render/src/TermsInput/TermsInput.js